
  $(document).ready(function(){ 
    var navHeight = $('.main-navigation').outerHeight();
    $('#MainContent').css('margin-top', navHeight + 'px');
  });

const cdnBase = "https://cdn.shopify.com/s/files/1/0043/1548/0177/files/";
const eggOffers = {
  blue: [
    { img: 'WEB-EASTER-EGGS-03.png', type: 'discount', code: 'EASTER20' },
    { img: 'WEB-EASTER-EGGS-05.png', type: 'discount', code: 'EASTEREXPRESS' },
    { img: 'WEB-EASTER-EGGS-04.png', type: 'product_with_discount', productId: '51966144217452', discountCode: 'EASTERMINI' },
    { img: 'WEB-EASTER-EGGS-06.png', type: 'discount', code: 'EASTERMYSTERY' },
    { img: 'WEB-EASTER-EGGS-14.png', type: 'product_with_discount', productId: '51965578543468', discountCode: 'EASTERGLOSS' }
  ],
  yellow: [
    { img: 'WEB-EASTER-EGGS-10.png', type: 'discount', code: 'EASTER20' },
    { img: 'WEB-EASTER-EGGS-12.png', type: 'discount', code: 'EASTEREXPRESS' },
    { img: 'WEB-EASTER-EGGS-11.png', type: 'product_with_discount', productId: '51966144217452', discountCode: 'EASTERMINI' },
    { img: 'WEB-EASTER-EGGS-13.png', type: 'discount', code: 'EASTERMYSTERY' },
    { img: 'WEB-EASTER-EGGS-14.png', type: 'product_with_discount', productId: '51965578543468', discountCode: 'EASTERGLOSS' }
  ],
  pink: [
    { img: 'WEB-EASTER-EGGS-18.png', type: 'discount', code: 'EASTERMYSTERY' },
    { img: 'WEB-EASTER-EGGS-17.png', type: 'discount', code: 'EASTEREXPRESS' },
    { img: 'WEB-EASTER-EGGS-16.png', type: 'product_with_discount', productId: '51966144217452', discountCode: 'EASTERMINI' },
    { img: 'WEB-EASTER-EGGS-15.png', type: 'discount', code: 'EASTER20' },
    { img: 'WEB-EASTER-EGGS-14.png', type: 'product_with_discount', productId: '51965578543468', discountCode: 'EASTERGLOSS' }
  ]
};
let eggRateLocked = false;
function showSpinner(eggImgSrc) {
  const wrapper = document.getElementById('egg-spinner');
  const img = document.getElementById('egg-spinner-img');
  if (img && eggImgSrc) img.src = eggImgSrc;
  if (wrapper) wrapper.style.display = 'flex';
}

function hideSpinner() {
  const wrapper = document.getElementById('egg-spinner');
  if (wrapper) wrapper.style.display = 'none';
}

// Preload all back images
Object.values(eggOffers).flat().forEach(offer => {
  const img = new Image();
  img.src = `${cdnBase}${offer.img}?v=1744699150`;
});




function applyOffer(offer) {
  const currentURL = window.location.pathname + window.location.search;
  const spinnerText = document.getElementById('egg-spinner-text');
  const expressPrize = document.querySelector('.express-prize');
  const prevBonus = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
  const prevDiscount = sessionStorage.getItem('activeDiscountCode');

 const removePreviousPrize = () => {
  return new Promise((resolve) => {
    const bonusJSON = sessionStorage.getItem('bonusProduct');
    const prevBonus = bonusJSON ? JSON.parse(bonusJSON) : null;

    if (prevBonus) {
      // Remove the bonus product from the cart
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: prevBonus.productId, quantity: 0 })
      })
      .then(() => {
        console.log(`[Egg Hunt] Removed previous bonus product ID ${prevBonus.productId}`);
        // Only clear session after removal attempt finishes
        sessionStorage.removeItem('activeDiscountCode');
        sessionStorage.removeItem('bonusProduct');
        resolve();
      })
      .catch(err => {
        console.warn('[Egg Hunt] Failed to remove previous bonus product:', err);
        // Clear session even on failure
        sessionStorage.removeItem('activeDiscountCode');
        sessionStorage.removeItem('bonusProduct');
        resolve();
      });
    } else {
      resolve();
    }
  });
};


const applyDiscountRedirect = (code) => {
  sessionStorage.setItem('activeDiscountCode', code);
 sessionStorage.setItem('openCartAfterDiscount', 'true');

  if (code === 'EASTEREXPRESS') {
    if (spinnerText) spinnerText.textContent = "Your FREE Express Shipping will be visible whilst Checking Out";
    if (expressPrize) expressPrize.classList.add('active');
  }

  setTimeout(() => {
    hideSpinner();
    window.location.href = `/discount/${code}?redirect=${encodeURIComponent(currentURL)}`;
  }, 1000);
};


  const addBonusProductAndApplyDiscount = () => {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: offer.productId, quantity: 1 })
    })
    .then(res => res.json())
    .then(() => {
      sessionStorage.setItem('activeDiscountCode', offer.discountCode);
      sessionStorage.setItem('bonusProduct', JSON.stringify({
        productId: offer.productId,
        discountCode: offer.discountCode
      }));

      if (offer.discountCode === 'EASTEREXPRESS') {
        if (spinnerText) spinnerText.textContent = "Your FREE Express Shipping will be visible when Checking Out";
        if (expressPrize) expressPrize.classList.add('active');
      }

      if (window.UpCart) UpCart.refreshCart();

      setTimeout(() => {
        hideSpinner();
        window.location.href = `/discount/${offer.discountCode}?redirect=${encodeURIComponent(currentURL)}`;
      }, 1100);
    })
    .catch(err => {
      alert('❌ Add to cart failed: ' + err);
      hideSpinner();
      eggRateLocked = false;
    });
  };

  removePreviousPrize().then(() => {
    // 🥚 DISCOUNT ONLY
    if (offer.type === 'discount') {
      console.log('[Egg Hunt] Applying discount-only offer:', offer.code);
      applyDiscountRedirect(offer.code);
    }

    // 🥚 PRODUCT + DISCOUNT
    else if (offer.type === 'product_with_discount') {
      console.log('[Egg Hunt] Applying product + discount offer:', offer.productId, offer.discountCode);
      addBonusProductAndApplyDiscount();
    }
  });
}

function monitorCartRewardCleanup() {
  const CHECK_INTERVAL = 3500;

  setInterval(() => {
    const bonus = JSON.parse(sessionStorage.getItem('bonusProduct') || 'null');
    const activeCode = sessionStorage.getItem('activeDiscountCode');

    if (!bonus || !activeCode) return;

    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        const discountExists = cart.cart_level_discount_applications?.some(
          d => d.code === bonus.discountCode
        );
        const productInCart = cart.items?.some(
          item => item.variant_id == bonus.productId
        );

        if (!discountExists && productInCart) {
          console.log('[Egg Hunt] Bonus product in cart without matching discount. Removing…');

          fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: bonus.productId, quantity: 0 })
          })
          .then(() => {
            sessionStorage.removeItem('activeDiscountCode');
            sessionStorage.removeItem('bonusProduct');
            if (window.UpCart) UpCart.refreshCart();

            const expressPrize = document.querySelector('.express-prize');
            if (expressPrize) expressPrize.classList.remove('active');

            console.log(`[Egg Hunt] Removed bonus product ${bonus.productId} after discount was removed.`);
          })
          .catch(err => console.warn('❌ Bonus product cleanup failed:', err));
        }
      })
      .catch(err => console.warn('❌ Cart fetch failed for reward cleanup:', err));
  }, CHECK_INTERVAL);
}

function pickWeightedReward(rewards, discountWeight = 0.65) {
  const discounts = rewards.filter(r => r.type === 'discount');
  const productWithDiscounts = rewards.filter(r => r.type === 'product_with_discount');

  const roll = Math.random();
  console.log(`[Egg Hunt] 🎲 Random roll: ${roll.toFixed(4)} (threshold: ${discountWeight})`);

  let chosen = null;

  if (roll < discountWeight && discounts.length > 0) {
    chosen = discounts[Math.floor(Math.random() * discounts.length)];
    console.log('[Egg Hunt] 🎁 Chosen type: discount');
  } else if (productWithDiscounts.length > 0) {
    chosen = productWithDiscounts[Math.floor(Math.random() * productWithDiscounts.length)];
    console.log('[Egg Hunt] 🎁 Chosen type: product_with_discount');
  } else if (discounts.length > 0) {
    chosen = discounts[Math.floor(Math.random() * discounts.length)];
    console.log('[Egg Hunt] 🎁 Fallback: discount (only type left)');
  }

  return chosen;
}



document.querySelectorAll('.flip-container').forEach(container => {
  container.addEventListener('click', () => {
    if (container.classList.contains('flipped')) return;

    const color = container.dataset.color;
    const offers = eggOffers[color];
    const chosen = pickWeightedReward(offers); // ← using weighted logic now

    if (!chosen) return; // safety check

    const backImg = container.querySelector('.back');
    const backImgUrl = `${cdnBase}${chosen.img}?v=1744337695`;
    backImg.src = backImgUrl;

    backImg.onload = () => {
      container.classList.add('flipped');
      setTimeout(() => {
        showSpinner(backImgUrl);
        applyOffer(chosen);
      }, 900);
    };
  });
});


window.addEventListener('load', function() {
  // Delay a bit to ensure all scripts are fully initialized
  setTimeout(function(){
    if (sessionStorage.getItem('openCartAfterDiscount') === 'true') {
      sessionStorage.removeItem('openCartAfterDiscount');
      if (window.UpCart && typeof window.UpCart.openCart === 'function') {
        console.log('[Egg Hunt] Opening cart via UpCart.openCart()');
        window.UpCart.openCart();
      } else {
        // Fallback: adjust the selector to match your theme's cart toggle element
        var cartToggleButton = document.querySelector('.header__icon--cart');
        if (cartToggleButton) {
          console.log('[Egg Hunt] Opening cart via simulated click.');
          cartToggleButton.click();
        } else {
          console.warn('[Egg Hunt] Cart toggle button not found.');
        }
      }
    }
  }, 1500); // adjust delay if necessary
});

